const styles = () => ({
  rootChip: {
    '&.MuiChip-root': {
      borderRadius: '40px !important',
      height: 28,
      fontSize: '12px',
      fontWeight: 500,
      width: 'fit-content',
      marginLeft: '5px',
      alignItems: 'center'
    }
  },
  chipOutlined: {
    '&.MuiChip-outlined': {
      color: '#4658be',
      backgroundColor: '#deeafc',
      borderColor: '#deeafc',
    }
  },
  icon: {
    fontSize: '16px',
    color: '#4658be'
  }
});

export default styles;